import React from 'react';
import { ConfigProvider, InputNumber, Tooltip } from 'antd';
import { semantic } from '../../theme/tokens';

// A custom (per-store) price gets a success-tinted border so it stands out from the general one.
const CUSTOM_THEME = {
    components: {
        InputNumber: {
            colorBorder: semantic.success.border,
            hoverBorderColor: semantic.success.solid,
            activeBorderColor: semantic.success.solid,
            colorBgContainer: semantic.success.bg
        }
    }
};

/**
 * Celda de precio editable en línea (USD).
 *
 * Mantiene el valor tecleado en estado local y solo guarda al salir del campo o
 * al presionar Enter, para no disparar una petición por cada tecla.
 */
export default function PriceCell({ value = 0, onSave, disabled = false, isCustom = false, tooltip }) {
    const [draft, setDraft] = React.useState(value);

    React.useEffect(() => {
        setDraft(value);
    }, [value]);

    const commit = () => {
        const price = Number(draft) || 0;
        if (price === Number(value)) return;
        onSave?.(price);
    };

    // Custom prices are wrapped in a success-tinted theme.
    const themed = (node) => (isCustom ? <ConfigProvider theme={CUSTOM_THEME}>{node}</ConfigProvider> : node);

    const input = (
        <InputNumber
            value={draft}
            onChange={(next) => setDraft(next ?? 0)}
            onBlur={commit}
            onPressEnter={commit}
            min={0}
            step={1}
            precision={2}
            prefix="$"
            size="small"
            disabled={disabled}
            className="w-[130px] tabular-nums"
        />
    );

    return tooltip ? <Tooltip title={tooltip}><span className="inline-flex">{themed(input)}</span></Tooltip> : themed(input);
}
